import React, { Component } from 'react';
import {
  Banner,
  Button,
  ConfirmPanel,
  ErrorBottomSheet,
  ModalConfirm,
  ModalInput,
  ModalInfo,
} from 'components';
import { isEmpty, get, has, filter, groupBy } from 'lodash';
import { HELPER, JsBridge } from 'utils';
import vanillaToast from 'vanilla-toast';
import 'vanilla-toast/vanilla-toast.css';
import {
  PHONE_NUMBER,
  AMOUNT_BILL,
  BILLER_PAGE,
  CUSTOMER_NUMBER,
  CACHE_CUSTOMER_NUMBER,
  CACHE_AMOUNT,
  CACHE_FROM_TNC,
  CACHE_FROM_PAYMENT,
  PREFIX,
  ITERATE_RETRY,
} from 'constant/ConstVariable';
import {
  ERROR_NOT_FOUND,
  ERROR_DEFAULT,
  ERROR_UNAUTHORIZED,
  ERROR_TRANSFER_DESTINATION_UNAVAILABLE,
  ERROR_INVALID_AMOUNT,
  ERROR_BILL_ALREADY_PAID,
  ERROR_BILL_ALREADY_EXPIRED,
  ERROR_BILLER_PAYMENT_NOT_FOUND,
  ERROR_INFO,
} from 'assets';

import FormBuilder from 'containers/FormBuilder/FormBuilder.container';
import RepeatOrder from 'components/FormBuilder/components/RepeatOrder/RepeatOrder.component';
import pkg from '../../../package.json';

import config from './GeneralFormPage.page.config';
import text from './GeneralFormPage.page.translation';
import './GeneralFormPage.less';

export class GeneralFormPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      biller: {},
      forms: {},
      panelVisible: false,

      billerImage: [],
      billerPrefix: [],
      attemptVer: 0,
      nameModalVisible: false,
      nameModalDefaultValue: '',

      customerNumber: '',
      modalConfirmVisible: false,
      modalConfirmTitle: '',
      modalConfirmDesc: '',
      modalConfirmBtn: {},

      modalInfoVisible: false,

      bottomSheetErrorVisible: false,
      bottomSheetErrorData: {
        img: '',
        title: '',
        desc: '',
      },
      bottomSheetErrorBtn: {
        text: '',
        onClick: () => {},
      },
      bottomSheetErrorOnChange: () => {},

      selectedPrefix: null,
      recentTrx: [],
      recentTrxActive: -1,
      recentTrxSelected: {
        customer_number: null,
        amount: null,
      },
      payerName: '',
      iterateRetry: 0,
      isGenesis: false,
      tncAgreement: [],
      billerWithTnc: false,
      checkedTnc: false,
    };
  }

  static getDerivedStateFromProps(prevProps) {
    if (!isEmpty(prevProps.biller)) {
      return {
        biller: prevProps.biller,
        forms: prevProps.formData,
      };
    }
    return null;
  }

  initData = async () => {
    const {
      match: { params },
      getBiller,
      getBillerPrefix,
      getBillerRecentTrx,
      getForm,
      getAgreementTNC,
    } = this.props;
    const idBiller = params.id;
    try {
      const biller = await getBiller(idBiller);

      // Check Biller Available
      if (biller.status === 200) {
        const { payload, status } = biller.data;
        const title = payload.service.public_name || payload.service.name;
        // Check Status
        if (status === 'success') {
          const formID = get(
            payload,
            'form.id',
            payload.service.default_form_id,
          );
          const billerImage = get(
            payload,
            'banner_abs_url',
            payload.service.banner_abs_url,
          );
          // Set Title
          document.addEventListener(
            'AlipayJSBridgeReady',
            () => {
              JsBridge.setTitle(title);
            },
            false,
          );
          const prefix = await getBillerPrefix(payload.id);
          const form = await getForm(formID);
          const parsedComponent = JSON.parse(
            get(form, 'data.payload.components') || '{}',
          );

          let recentTrx = [];
          if (
            get(parsedComponent, 'sectionHeader') === 'repeat' ||
            get(parsedComponent, 'sectionHeader') === 'both'
          ) {
            recentTrx = await getBillerRecentTrx(payload.id);
          }
          // GET TNC AGREEMENT
          let tncAgreement = [];
          if (payload.tnc) {
            tncAgreement = await getAgreementTNC(payload.tnc.public_id);
          }
          return Promise.resolve({
            biller,
            prefix,
            form,
            billerImage,
            recentTrx,
            tncAgreement,
          });
        }
        throw new Error(404);
      } else {
        throw new Error(400);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  };

  _getNewStateOnHashChange = val => {
    let result = {
      panelVisible: false,
      bottomSheetErrorVisible: false,
      modalConfirmVisible: false,

      nameModalVisible: false,
      upgradeKycVisible: false,
    };

    let getHash = '';
    const splitResult = val.newURL.split('#');
    if (splitResult.length > 1) {
      const [, hashValue] = splitResult;
      getHash = hashValue;
    }

    switch (getHash) {
      case 'confirmPanel':
        result.panelVisible = true;
        break;
      case 'nameModal':
      case 'errorLimitModal':
      case 'errorBalanceModal':
      case 'errorPanel':
      case 'upgradeKycPanel':
        result = '';
        break;
      default:
        break;
    }

    return result;
  };

  _onHashChange = val => {
    const newState = this._getNewStateOnHashChange(val);

    if (newState) {
      this.setState(newState);
    }
  };

  componentDidMount() {
    JsBridge.setDefaultBack();
    window.onhashchange = this._onHashChange;
    this.props.setFormDataValue({});
    this.initData()
      .then(this.successGetBiller)
      .catch(this.onErrorGetBiller);
  }

  _checkBillerAvailable = () => {
    const { biller } = this.state;
    const {
      intl: { formatMessage },
    } = this.props;
    const availOnSkw = window.IS_IN_SKYWALKER && biller.skyw_status === 1;
    const availOnPg = window.IS_IN_PLAYGROUND && biller.pground_status === 1;
    if (availOnSkw || availOnPg) {
      this._showErrorPanel({
        title: formatMessage(text.errorMessage.billerInactive.title),
        description: formatMessage(text.errorMessage.billerInactive.desc),
        icon: ERROR_UNAUTHORIZED,
        btn: {
          text: formatMessage(text.buttonBack).toUpperCase(),
          onClick: this._handleBacktoList(true),
        },
      });
    }
  };

  predefineValue = () => {
    const { forms } = this.state;
    const { updateFieldForm } = this.props;
    const cacheAccountNumber =
      sessionStorage.getItem(CACHE_CUSTOMER_NUMBER) || '';
    const cacheAmount = sessionStorage.getItem(CACHE_AMOUNT) || '';

    const fromCache = sessionStorage.getItem(CACHE_FROM_TNC) === 'true';
    const fromPayment = sessionStorage.getItem(CACHE_FROM_PAYMENT) === 'true';

    const formObj = JSON.parse(get(forms, 'components') || '{}');

    const showPrefix = has(formObj, 'showPrefix')
      ? get(formObj, 'showPrefix')
      : 'no';
    const validationPrefix = has(formObj, 'validationPrefix')
      ? get(formObj, 'validationPrefix')
      : 'dynamic';
    // check biller status
    this._checkBillerAvailable();

    let valueParamAccount =
      HELPER.getParamURL(CUSTOMER_NUMBER) ||
      HELPER.getParamURL(PHONE_NUMBER) ||
      cacheAccountNumber;

    let amount = HELPER.getParamURL(AMOUNT_BILL);
    let prefixAccount = HELPER.getParamURL(PREFIX);
    let customerNumber = '';

    if (fromCache || fromPayment) {
      valueParamAccount = cacheAccountNumber;
      amount = cacheAmount;
    }

    // Cheking if has added by prefix or cache
    if (fromPayment && prefixAccount !== '') {
      prefixAccount = '';
    }

    if (
      (validationPrefix === 'yes' ||
        (validationPrefix === 'dynamic' && showPrefix === 'yes')) &&
      !fromCache
    ) {
      customerNumber = prefixAccount + valueParamAccount;
    } else {
      const isPhoneNumberInput =
        get(formObj, 'components[0].component') === 'PhoneNumberInput';
      customerNumber =
        valueParamAccount && isPhoneNumberInput && !fromCache && !fromPayment
          ? `08${valueParamAccount}`
          : valueParamAccount;
    }

    const paramAvailable = customerNumber || amount;
    this._mapRecentTrxData();
    if (paramAvailable) {
      updateFieldForm('customer_number', customerNumber.substring(0, 18));
      updateFieldForm('amount', HELPER.parseNumber(amount || 0));

      sessionStorage.removeItem(CACHE_CUSTOMER_NUMBER);
      sessionStorage.removeItem(CACHE_AMOUNT);
      sessionStorage.removeItem(CACHE_FROM_PAYMENT);
      sessionStorage.removeItem(CACHE_FROM_TNC);
    }
  };

  onErrorGetBiller = () => {
    this.props.setErrorState(true);
  };

  successGetBiller = result => {
    const { billerImage, prefix, recentTrx, tncAgreement } = result;
    this.trackFormOpen();

    const isGenesis = prefix.some(item => !item.default_need_amount);
    this.setState(
      {
        billerPrefix: prefix,
        billerImage,
        recentTrx,
        isGenesis,
        tncAgreement,
      },
      this.predefineValue,
    );
  };

  trackFormOpen = () => {
    const {
      biller: { name: billerName },
      trackEvent,
    } = this.props;

    const params = { 'Biller Name': billerName };

    if (!this.isFromBiller()) {
      params.Source = HELPER.getParamURL('entryPoint') || 'X2B';
    }

    trackEvent('Form Open', params);
  };

  _handlePressBack = () => {
    // Pas Back to Before Page
    this.props.history.goBack();
  };

  _handleBacktoList = errorCheckout => () => {
    // Pas Back to Before Page
    const fromBiller = this.isFromBiller();
    if (fromBiller && errorCheckout) this.props.history.go(-2);
    else if (fromBiller) this.props.history.go(-3);
    else {
      JsBridge.close();
    }
  };

  _getPrefixIndex = value =>
    this.state.billerPrefix.findIndex(
      ({ va_prefix: prefix }) => prefix === value.substring(0, prefix.length),
    );

  _requestCheckout = () => {
    const {
      biller,
      forms,
      billerPrefix,
      payerName,
      isGenesis,
      tncAgreement,
    } = this.state;
    const { additionalInfo } = this.props;

    const accountValue = get(this.props, 'formValue.customer_number');
    sessionStorage.setItem(CACHE_CUSTOMER_NUMBER, accountValue);
    const customerNumber = accountValue.replace(/\s/g, '');
    const statusClosedBiller = get(biller, 'is_closed_amount');
    const amount = get(this.props, 'formValue.amount', 0).toString();
    this.setState({ customerNumber });
    // Real

    let value = {
      biller_id: biller.id,
      customer_number: customerNumber,
      transaction_amount: amount,
      additional_info: { ...additionalInfo },
    };

    if (isGenesis && statusClosedBiller) {
      value = {
        biller_id: biller.id,
        customer_number: customerNumber,
        additional_info: { ...additionalInfo },
      };
    }

    const data = value;
    let prefixs = [];
    let selectedPrefix = null;
    if (billerPrefix.length) {
      prefixs = groupBy(billerPrefix, 'priority')['1'].map(
        obj => obj.va_prefix,
      );
    }

    const formObj = JSON.parse(get(forms, 'components') || '{}');
    const validationPrefix = has(formObj, 'validationPrefix')
      ? get(formObj, 'validationPrefix')
      : 'dynamic';
    const dynamicValidPrefix = validationPrefix !== 'yes';
    const { components } = formObj;
    const selectedPrefixIndex = this._getPrefixIndex(value.customer_number);
    const [firstPrefix] = billerPrefix;

    if (
      components[0].component === 'PhoneNumberInput' &&
      value.customer_number.match(/^\(?(628|08)\)?\d/)
    ) {
      const phoneNumber = value.customer_number.match(/^\(?(628)\)?\d/)
        ? value.customer_number.replace(/^.{2}/g, '0')
        : value.customer_number;
      data.customer_number = `${prefixs[0]}${phoneNumber.slice(2)}`;
      selectedPrefix = firstPrefix;
    } else if (
      biller.biller_type === 2 &&
      ((dynamicValidPrefix && selectedPrefixIndex === -1) ||
        validationPrefix === 'no')
    ) {
      data.customer_number = `${prefixs[0]}${value.customer_number}`;
      selectedPrefix = firstPrefix;
    } else if (biller.biller_type === 2 && selectedPrefixIndex !== -1) {
      selectedPrefix = billerPrefix[selectedPrefixIndex];
    }

    if (payerName) {
      data.payer_name = payerName;
    }

    this.props.setFormDataValue({
      ...data,
      selectedPrefix,
      customerNumber,
    });

    this.props
      .createCheckout(data)
      .then(success => {
        if (success) {
          // BASIC CONDITION TNC
          // When you modify the agreement you need to remember basic tnc condition flow heres comment for remain for those of you who want to make change on tnc
          // 1 IF biller HAVE tnc && agreement <= 0
          //  a. dont show modal
          //  b. set biller have tnc thick
          // 2. IF biller tnc Length > 0 && HAVE tnc && tnc version biller dan tnc user DIFFERENT
          //  a. show popup stop
          //  b. set biller have tnc thick
          // else Biller STANDARD
          // a. set biller without tnc
          // IF THERE IS UPDATE ON AGREEMENT
          if (biller.tnc && tncAgreement.length <= 0) {
            // Set Value Cheklist un Checklist
            // console.log('MASUK TNC 1');
            this.setState(
              {
                checkedTnc: false,
                billerWithTnc: true,
                panelVisible: true,
                selectedPrefix,
              },
              this._checkoutSuccess,
            );
          } else if (biller.tnc && tncAgreement.length > 0) {
            if (
              get(biller, 'tnc.latest_version_name', '') ===
              get(tncAgreement, '0.tnc_version_name', null)
            ) {
              this.setState(
                {
                  checkedTnc: true,
                  billerWithTnc: true,
                  panelVisible: true,
                  selectedPrefix,
                },
                this._checkoutSuccess,
              );
            } else {
              this.setState({
                selectedPrefix,
                checkedTnc: false,
                billerWithTnc: true,
                modalInfoVisible: true,
              });
            }
          } else {
            this.setState(
              {
                checkedTnc: false,
                billerWithTnc: false,
                panelVisible: true,
                selectedPrefix,
              },
              this._checkoutSuccess,
            );
          }
        }
      })
      .catch(this._onCheckoutError(true));
  };

  _closeInfo = () => {
    this.setState(
      {
        modalInfoVisible: false,
        panelVisible: true,
      },
      this._checkoutSuccess,
    );
  };

  _submitForm = () => {
    this.setState({ iterateRetry: ITERATE_RETRY }, this._requestCheckout);
  };

  _retryRequest = errorCheckout => {
    this.setState(
      prevState => ({ iterateRetry: prevState.iterateRetry - 1 }),
      () => {
        if (errorCheckout) {
          this._requestCheckout();
        } else {
          this._requestPay();
        }
      },
    );
  };

  _onCheckoutError = errorCheckout => err => {
    const {
      intl: { formatMessage },
      history,
    } = this.props;

    const title = get(err, 'response.data.message.title', '');
    this.props.setLoading(false);
    // Custom Error Message
    const defaultMessage = {
      title: formatMessage(text.errorMessage.default.title),
      description: formatMessage(text.errorMessage.default.desc),
      icon: ERROR_DEFAULT,
    };

    switch (title) {
      case 'AMOUNT_NOT_FOUND':
      case 'AMOUNT_AND_PAYER_INFO_NOT_FOUND':
        history.push({
          pathname: '/genesis',
          state: {
            error: title,
          },
        });
        break;
      case 'TRANSFER_DESTINATION_UNAVAILABLE':
        if (this.state.iterateRetry === 0) {
          this._showErrorPanel({
            title: formatMessage(
              text.errorMessage.transferDestinationUnavailable.title,
            ),
            description: formatMessage(
              text.errorMessage.transferDestinationUnavailable.desc,
            ),
            icon: ERROR_TRANSFER_DESTINATION_UNAVAILABLE,
            btn: {
              text: this.props.intl.formatMessage(text.buttonClose),
              onClick: this._handlePressBack,
            },
          });
        } else {
          this._retryRequest(errorCheckout);
        }
        break;
      case 'INVALID_AMOUNT':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.invalidAmount.title),
          description: formatMessage(text.errorMessage.invalidAmount.desc),
          icon: ERROR_INVALID_AMOUNT,
          btn: {
            text: this.props.intl.formatMessage(text.buttonClose),
            onClick: this._handlePressBack,
          },
        });
        break;
      case 'BILL_ALREADY_PAID':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.billAlreadyPaid.title),
          description: formatMessage(text.errorMessage.billAlreadyPaid.desc),
          icon: ERROR_BILL_ALREADY_PAID,
          btn: {
            text: this.props.intl.formatMessage(text.buttonClose),
            onClick: this._handlePressBack,
          },
        });
        break;
      case 'BILL_ALREADY_EXPIRED':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.billAlreadyExpired.title),
          description: formatMessage(text.errorMessage.billAlreadyExpired.desc),
          icon: ERROR_BILL_ALREADY_EXPIRED,
          btn: {
            text: this.props.intl.formatMessage(text.buttonClose),
            onClick: this._handlePressBack,
          },
        });
        break;
      case 'BILL_PAYMENT_NOT_FOUND':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.billerPaymentNotFound.title),
          description: formatMessage(
            text.errorMessage.billerPaymentNotFound.desc,
          ),
          icon: ERROR_BILLER_PAYMENT_NOT_FOUND,
          btn: {
            text: this.props.intl.formatMessage(text.buttonClose),
            onClick: this._handlePressBack,
          },
        });
        break;
      case 'CHANNEL_UNABLE_TO_PROCESS':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.channelUnableToProcess.title),
          description: formatMessage(
            text.errorMessage.channelUnableToProcess.desc,
          ),
          icon: ERROR_INFO,
          btn: {
            text: this.props.intl.formatMessage(text.buttonClose),
            onClick: this._handlePressBack,
          },
        });
        break;
      case 'TRANSFER_DESTINATION_NOT_FOUND':
        if (this.state.iterateRetry === 0) {
          this.setState({ nameModalVisible: false });
          this._showErrorPanel({
            title: formatMessage(text.errorMessage.accountNotFound.title),
            description: formatMessage(text.errorMessage.accountNotFound.desc),
            icon: ERROR_NOT_FOUND,
            btn: {
              text: this.props.intl.formatMessage(text.buttonClose),
              onClick: this._handlePressBack,
            },
          });
        } else {
          this._retryRequest(errorCheckout);
        }
        break;

      case 'PAYER_INFO_NOT_FOUND':
        this._showNameModal(err);
        break;
      case 'FORBIDDEN':
        this._handlePressBack();
        break;
      case 'ORDER_BILLER_INACTIVE':
        this._showErrorPanel({
          title: formatMessage(text.errorMessage.billerInactive.title),
          description: formatMessage(text.errorMessage.billerInactive.desc),
          icon: ERROR_UNAUTHORIZED,
          btn: {
            text: formatMessage(text.buttonBack).toUpperCase(),
            onClick: this._handleBacktoList(errorCheckout),
          },
        });
        break;
      case 'INTEGRATION_ERROR':
      case 'DANA_SYSTEM_ERROR':
      case 'TRANSFER_NETWORK_ERROR':
      case 'BILLER_CODE_INVALID':
      case 'DANA_RISK_REJECT':
      default:
        this._showErrorPanel(defaultMessage);
        break;
    }
  };

  _showNameModal = err => {
    const defaultName = this._getDefaultName(err);
    this.setState(
      {
        nameModalVisible: true,
        nameModalDefaultValue: defaultName,
      },
      this._updateHashUrl('#nameModal'),
    );
  };

  _updateHashUrl = hash => {
    window.location.assign(hash);
  };

  _replaceHashUrl = hash => {
    window.location.replace(hash);
  };

  _getDefaultName = err => {
    let result = '';
    const nickname = get(
      err,
      'response.data.message.additional_info.payer_nickname',
      '',
    );

    if (nickname) {
      const isValid = this._isNicknameValid(nickname);

      if (isValid) {
        result = nickname;
      }
    }

    return result;
  };

  _isNicknameValid = nickname => {
    const regex = /^[a-zA-Z ]*[a-zA-Z]+[a-zA-Z ]*$/;
    return regex.test(nickname);
  };

  _showErrorPanel = errorMessage => {
    // Build Data Panel
    // Save State
    this.setState(
      {
        bottomSheetErrorVisible: true,
        bottomSheetErrorData: {
          img: errorMessage.icon,
          title: errorMessage.title,
          desc: errorMessage.description,
        },
        bottomSheetErrorBtn: errorMessage.btn || {
          text: this.props.intl.formatMessage(text.buttonClose),
          onClick: this._handlePressBack,
        },
        bottomSheetErrorOnChange: this._onChangeError,
        nameModalVisible: false,
      },
      this._updateHashUrl('#errorPanel'),
    );
  };

  _valueChanged = field => value => {
    const { recentTrxSelected } = this.state;

    if (
      (field === 'amount' && value !== recentTrxSelected.amount) ||
      (field === 'customer_number' &&
        value !== recentTrxSelected.customer_number)
    ) {
      this.setState({ recentTrxActive: -1 });
    }
  };

  _renderFormBuilder = (formData, lang) => {
    const {
      intl: { formatMessage },
      intl,
      biller,
    } = this.props;

    const messageEmpty = (
      <center>
        <br />
        <br />
        <h2>{formatMessage(text.emptyform)}</h2>
        <p>{formatMessage(text.emptyFormDesc)}</p>
      </center>
    );
    // Check Empty Form Data & String
    if (isEmpty(formData) || formData.components === '') {
      return messageEmpty;
    }
    // Parsing The Component
    const componentParse = JSON.parse(get(formData, 'components') || '{}');
    let { components } = componentParse;
    const vaPrefix = this.state.billerPrefix.map(item => item.va_prefix);
    // Additional Cheking
    const statusClosedBiller = get(biller, 'is_closed_amount');

    if (this.state.isGenesis && statusClosedBiller) {
      // Check if component length if empty
      const arrayNonPayment = [];
      componentParse.components.forEach(item => {
        if (
          item.component !== 'AmountInput' &&
          item.component !== 'AmountInputPredefined'
        ) {
          arrayNonPayment.push(item);
        }
      });
      components = arrayNonPayment;
    }

    if (components.length <= 0) {
      return messageEmpty;
    }
    return (
      <FormBuilder
        formData={formData}
        lang={lang}
        formObject={components}
        onSubmit={this._submitForm}
        billerData={this.state.biller}
        vaPrefix={vaPrefix}
        intl={intl}
        history={this.props.history}
        valueChanged={this._valueChanged}
      />
    );
  };

  _renderProvider = (formData, lang) => {
    const {
      intl: { formatMessage },
    } = this.props;

    if (isEmpty(formData)) {
      return '';
    }
    if (formData.components === '') {
      return formatMessage(text.emptyform);
    }
    const componentParse = JSON.parse(get(formData, 'components') || '{}');

    return get(componentParse, `${lang}.title`, '');
  };

  _onChangePanel = isOpen => {
    const { history } = this.props;
    if (isOpen) {
      this.setState(
        {
          panelVisible: true,
        },
        this._replaceHashUrl('#confirmPanel'),
      );
    } else {
      history.goBack();
    }
  };

  _onChangeError = isOpen => {
    const { history } = this.props;
    if (isOpen) {
      this.setState(
        {
          bottomSheetErrorVisible: true,
        },
        this._updateHashUrl('#errorPanel'),
      );
    } else {
      history.goBack();
    }
  };

  _requestPay = () => {
    const { tncAgreement } = this.state;
    const { checkout, setLoading, requestPay, biller } = this.props;
    const salesOrderId = get(checkout, 'sales_order_id', '');
    setLoading(true);

    if (biller.tnc && tncAgreement.length <= 0) {
      this.agreeTnc(() => {
        requestPay(salesOrderId)
          .then(this._nextRequestPay)
          .catch(this._onCheckoutError(false));
      });
    } else if (biller.tnc && tncAgreement.length > 0) {
      if (
        get(biller, 'tnc.latest_version_name', '') ===
        get(tncAgreement, '0.tnc_version_name', null)
      ) {
        requestPay(salesOrderId)
          .then(this._nextRequestPay)
          .catch(this._onCheckoutError(false));
      } else {
        this.agreeTnc(() => {
          requestPay(salesOrderId)
            .then(this._nextRequestPay)
            .catch(this._onCheckoutError(false));
        });
      }
    } else {
      requestPay(salesOrderId)
        .then(this._nextRequestPay)
        .catch(this._onCheckoutError(false));
    }
  };

  agreeTnc = callback => {
    const { biller, signatureAgreementTNC } = this.props;
    const tncID = get(biller, 'tnc.public_id', '');
    const tncVersion = get(biller, 'tnc.latest_version_name', '');
    const date = new Date();
    const buildFingerprint = {
      userAgent: navigator.userAgent,
      dateTime: date.getTime(),
      timeZone: date.getTimezoneOffset(),
      lang: HELPER.getLang(),
    };
    const createSignature = btoa(JSON.stringify(buildFingerprint));
    const params = {
      signature: createSignature,
      version: tncVersion,
    };

    signatureAgreementTNC(tncID, params)
      .then(() => {
        callback();
      })
      .catch(this._onCheckoutError(false));
  };

  _panelConfirm = () => {
    this.setState({ iterateRetry: ITERATE_RETRY }, this._requestPay);
  };

  _nextRequestPay = result => {
    this._handlePressBack();
    this._trackOrder('Create Order');

    if (window.IS_IN_SKYWALKER) {
      JsBridge.call('callSubApp', {
        url: result.dana_cashier_url,
      });
    } else {
      window.location.assign(result.dana_cashier_url);
    }
    this.props.setLoading(false);
  };

  _checkoutSuccess = () => {
    this._trackOrder('Checkout Open');
    this._updateHashUrl('#confirmPanel');
  };

  _trackOrder = eventName => {
    const {
      intl: { locale },
      formValue: { amount },
      trackEvent,
    } = this.props;
    const { forms, selectedPrefix } = this.state;

    const params = {
      'VA Prefix': get(selectedPrefix, 'va_prefix'),
      'Biller Type': get(selectedPrefix, 'default_need_amount')
        ? 'Open VA'
        : 'Closed VA',
    };

    // Check Empty Form Data & String
    if (!isEmpty(forms) && forms.components !== '') {
      // Parsing The Component
      const componentParse = JSON.parse(get(forms, 'components') || '{}');
      const topUpComponent = componentParse.components.find(
        component => component.component === 'AmountInputPredefined',
      );
      const topUpConfig = get(topUpComponent, `config.${locale}.general`, {});

      Object.values(topUpConfig).forEach(value => {
        if (parseInt(value, 10) === amount) {
          params['Package Denom'] = amount;
        }
      });
    }

    trackEvent(eventName, params);
  };

  versioning = () => {
    const { attemptVer } = this.state;
    let adder = attemptVer + 1;
    // Click Seven Times
    if (adder > 6) {
      adder = 0;
      vanillaToast.show(`v${pkg.version}`);
    }
    this.setState({
      attemptVer: adder,
    });
  };

  _onSubmitInputSenderName = payerName => {
    this.setState(
      { iterateRetry: ITERATE_RETRY, payerName },
      this._requestCheckout,
    );
  };

  isFromBiller = () => sessionStorage.getItem(BILLER_PAGE);

  _onSelectROItem = (item, index) => () => {
    this.props.updateFieldForm(
      'customer_number',
      HELPER.formatAccount(item.account),
    );

    this.props.updateFieldForm('amount', HELPER.parseNumber(item.amount));
    this.setState({
      recentTrxActive: index,
      recentTrxSelected: {
        customer_number: HELPER.formatAccount(item.account),
        amount: HELPER.parseNumber(item.amount),
      },
    });
  };

  _getAccountRecent = (account, prefix) => {
    const { forms } = this.state;

    const formObj = JSON.parse(get(forms, 'components') || '{}');
    const { components } = formObj;
    const showPrefix = has(formObj, 'showPrefix')
      ? get(formObj, 'showPrefix')
      : 'no';

    // check phone number input
    if (showPrefix === 'yes') {
      return account;
    }

    // @TODO Deprecated on 2A
    const isPhoneNumber =
      get(components, '[0].component') === 'PhoneNumberInput';

    // check if prefix not equal with prefix from recent trx
    if (prefix.length && account.substring(0, prefix.length).match(prefix)) {
      return isPhoneNumber
        ? `08${account.substring(prefix.length)}`
        : account.substring(prefix.length);
    }

    return account;
  };

  _mapRecentTrx = recent => ({
    ...recent,
    account: this._getAccountRecent(recent.account, recent.prefix),
  });

  _callbackMapRecentTrx = recent => recent.account !== 'invalid';

  _mapRecentTrxData = () => {
    this.setState(prevState => ({
      recentTrx: filter(
        prevState.recentTrx.map(this._mapRecentTrx),
        this._callbackMapRecentTrx,
      ).slice(0, 3),
    }));
  };

  _handleChangeBill = () => {
    if (HELPER.getParamURL('entryPoint')) JsBridge.close();
    else this.props.history.goBack();
  };

  _renderHeader = () => {
    const { forms, billerImage, isGenesis } = this.state;
    const componentParse = JSON.parse(get(forms, 'components') || '{}');
    const sectionBanner = get(componentParse, 'sectionHeader');

    if (sectionBanner === 'none') return null;
    if (sectionBanner === 'repeat')
      return (
        <RepeatOrder
          orders={this.state.recentTrx}
          intl={this.props.intl}
          selectedIndex={this.state.recentTrxActive}
          onSelect={this._onSelectROItem}
          isGenesis={isGenesis}
        />
      );
    if (sectionBanner === 'banner') return <Banner imgSource={billerImage} />;
    return (
      <div
        id="section-banner"
        className={
          get(this.state, 'recentTrx.length', 0) < 1 ? 'no-recent-trx' : ''
        }
      >
        <Banner imgSource={billerImage} />
        <RepeatOrder
          orders={this.state.recentTrx}
          intl={this.props.intl}
          selectedIndex={this.state.recentTrxActive}
          onSelect={this._onSelectROItem}
          isGenesis={isGenesis}
        />
      </div>
    );
  };

  _getCustomerNumber = () => {
    const { forms, customerNumber, biller } = this.state;
    const formObj = JSON.parse(get(forms, 'components') || '{}');
    let custNumber = customerNumber;
    const selectedPrefixIndex = this._getPrefixIndex(customerNumber);

    const showPrefix = has(formObj, 'showPrefix')
      ? get(formObj, 'showPrefix')
      : 'no';

    const dontShowVA = showPrefix === 'no';
    const showVA = showPrefix === 'yes';
    const isPhoneNumber =
      get(formObj, 'components[0].component') === 'PhoneNumberInput';

    const validationPrefix = has(formObj, 'validationPrefix')
      ? get(formObj, 'validationPrefix')
      : 'dynamic';
    const noValidate = validationPrefix === 'no';

    if (
      (selectedPrefixIndex === -1 || noValidate) &&
      showVA &&
      biller.biller_type === 2
    ) {
      if (isPhoneNumber) {
        const phoneNumber = custNumber.match(/^\(?(628)\)?\d/)
          ? custNumber.slice(3)
          : custNumber.slice(2);

        return {
          custNumber:
            get(this.state, 'billerPrefix[0].va_prefix') + phoneNumber,
          prefix: this.state.selectedPrefix,
        };
      }
      return {
        custNumber: get(this.state, 'billerPrefix[0].va_prefix') + custNumber,
        prefix: this.state.selectedPrefix,
      };
    }

    if (selectedPrefixIndex !== -1 && dontShowVA) {
      custNumber = customerNumber.slice(
        get(
          this.state,
          `billerPrefix[${selectedPrefixIndex}].va_prefix.length`,
        ),
      );
      if (isPhoneNumber) {
        custNumber = `08${custNumber}`;
      }
    }

    return {
      custNumber,
      prefix: this.state.selectedPrefix,
    };
  };

  _onCheckTnc = () => {
    this.setState(prevState => ({
      checkedTnc: !prevState.checkedTnc,
    }));
  };

  render() {
    const {
      biller,
      forms,
      panelVisible,
      nameModalVisible,
      nameModalDefaultValue,

      modalConfirmVisible,
      modalConfirmTitle,
      modalConfirmDesc,
      modalConfirmBtn,

      modalInfoVisible,

      bottomSheetErrorVisible,
      bottomSheetErrorData,
      bottomSheetErrorBtn,
      bottomSheetErrorOnChange,
    } = this.state;
    const {
      isLoading,
      deviceHeight,
      intl: { formatMessage },
    } = this.props;

    const formObj = JSON.parse(get(forms, 'components') || '{}');
    const isShowTnc = get(formObj, `tnc.${HELPER.getLang()}.fileTnC`);

    return (
      <div
        className="form-wrapper"
        style={{
          minHeight: `${deviceHeight}px`,
          height: `${deviceHeight}px`,
        }}
      >
        <div
          className="biller-form"
          style={{ height: `calc(100% - ${isShowTnc ? 11.1 : 7.1}rem` }}
        >
          <div>{this._renderHeader()}</div>
          <p className="title-head">
            {this._renderProvider(forms, HELPER.getLang()) || forms.name}
          </p>
          <div className="biller-provider">
            <div className="icon" onClick={this.versioning}>
              <img src={biller.icon_abs_url} alt={biller.name} />
            </div>
            <div className="provider-text p-l-10">{biller.name}</div>
            <div className="button-nav p-r-10">
              {!isLoading && this.isFromBiller() && (
                <Button
                  id="btn_change"
                  addClass="outline"
                  action={this._handleChangeBill}
                  style={{
                    padding: '0.7rem',
                    width: '9.6rem',
                    fontSize: '1.2rem',
                    lineHeight: '1.6rem',
                  }}
                >
                  <span>{formatMessage(text.buttonChange)}</span>
                </Button>
              )}
            </div>
          </div>
          {this._renderFormBuilder(forms, HELPER.getLang())}
        </div>

        <ConfirmPanel
          {...this.props}
          customerNumber={this._getCustomerNumber()}
          visible={panelVisible}
          nameModalVisible={this.state.nameModalVisible}
          onChangePanel={this._onChangePanel}
          onCloseConfirmPanel={this._handlePressBack}
          onConfirm={this._panelConfirm}
          formValue={this.props.formValue}
          billerWithTnc={this.state.billerWithTnc}
          checkedTnc={this.state.checkedTnc}
          onCheckTnc={this._onCheckTnc}
        />

        <ModalInfo
          visible={modalInfoVisible}
          title={formatMessage(text.tnc.title)}
          desc={formatMessage(text.tnc.desc)}
          btn={formatMessage(text.tnc.btn)}
          onClose={this._closeInfo}
          icon={ERROR_INFO}
        />

        <ModalConfirm
          visible={modalConfirmVisible}
          title={modalConfirmTitle}
          desc={modalConfirmDesc}
          btn={modalConfirmBtn}
          onClose={this._handlePressBack}
        />

        <ModalInput
          visible={!isLoading && nameModalVisible}
          onClose={this._handlePressBack}
          onClickSubmit={this._onSubmitInputSenderName}
          title={formatMessage(text.senderNameTitle)}
          placeholder={formatMessage(text.senderNamePlaceholder)}
          btnLabel={formatMessage(text.senderNameAdd)}
          defaultValue={nameModalDefaultValue}
        />

        <ErrorBottomSheet
          visible={bottomSheetErrorVisible}
          btn={bottomSheetErrorBtn}
          error={bottomSheetErrorData}
          intl={this.props.intl}
          onChange={bottomSheetErrorOnChange}
          disableSwipe="true"
        />
      </div>
    );
  }
}

GeneralFormPage.propTypes = config.propTypes;
GeneralFormPage.displayName = config.displayName;
GeneralFormPage.defaultProps = config.defaultProps;

export default GeneralFormPage;
